export default __webpack_public_path__ + "assets/images/4b60fbed6e853cfef7b9843431d064cc.svg";